import { useEffect, useState } from "react";
import Avvvatars from "avvvatars-react";
import { my_routes } from "../router/all_routes";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { toast } from "sonner";
import { getAllTeachers } from "../../api/teachers";
import { recoverAccount } from "../../api/users";

import { deleteTeacher } from "../../api/teachers";
import { Link } from "react-router";
import { TeacherDataTable } from "../../core/data/interface";
import Table from "../../core/common/dataTable/index";
import TooltipOption from "./tooltipOption";
import withPermission from "../../core/common/autorisations/withPermission";
import { useAcademicYear } from "../../core/common/context/AcademicYearContext";
import InfosAlertYearDisabled from "../../core/common/alerts/infosAlertYearDisabled";
import {
  Action,
  buildPermission,
  Resource,
} from "../../core/common/autorisations/permissionsMap";
import DashboardMenu from "../user/admin/dashboardMenu";

//  restreindre l'acces à ce composant
const ProtectedAddTeacher = withPermission(
  (props: any) => (
    <div className="d-flex my-xl-auto right-content align-items-center">
      <TooltipOption updateData={props?.updateData} />
      <div className="mb-2">
        <Link
          to={props.routes.createTeacher}
          className="btn btn-primary d-flex align-items-center me-3"
        >
          <i className="ti ti-square-rounded-plus me-2" />
          Nouveau Professeur
        </Link>
      </div>
    </div>
  ),
  [buildPermission(Resource.TEACHER, Action.CREATE)],
  "masquer",
);

// bouton pour réinitialiser un mot de passe
const ProtectedBtnResetPasword = withPermission(
  (props: any) => (
    <li>
      <button
        disabled={!props.record.email}
        onClick={() => props.showConfirmationAlert(props.record)}
        className="dropdown-item rounded-1"
      >
        <i className="ti ti-menu me-2" />
        Mot de passe
      </button>
    </li>
  ),
  [buildPermission(Resource.REGISTRATION, Action.UPDATE)],
  "masquer",
);

// boutton protégée pour supprimer un professeur
const ProtectedBtnDeleteTeacher = withPermission(
  (props: any) => (
    <li>
      <button
        className="dropdown-item rounded-1"
        onClick={() => props.showdeleteTeacherConfirmationAlert(props.record)}
      >
        <i className="ti ti-trash-x me-2" />
        Supprimer
      </button>
    </li>
  ),
  [buildPermission(Resource.TEACHER, Action.DELETE)],
  "masquer",
);

const AllTeacher = () => {
  const routes = my_routes;
  const { selectedYear } = useAcademicYear();

  // Initialisation des state utilisés
  const [allTeachers, setAllTeachers] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true); // Pour le vrai chargement
  const [hasLoaded, setHasLoaded] = useState(false); // Pour éviter "Chargement..." quand il n'y a juste pas de données

  //Initialisation de sweetAlert
  const MySwal = withReactContent(Swal);

  //Traitement en alert de la demande de réinitialisation de mot de passe
  const showConfirmationAlert = (user: any) => {
    MySwal.fire({
      title: "Réinitialiser mot de passe ?",
      text: `Un e-mail contenant un lien sécurisé lui sera envoyé à ${user.firstname} ${user.lastname} pour lui permettre de définir un nouveau mot de passe.`,
      showCancelButton: true,
      // confirmButtonColor: "#00ff00",
      confirmButtonText: "Envoyer!",
      // cancelButtonColor: "#ff0000",
      cancelButtonText: "Annuler",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // ── Affiche le spinner pendant la requête ──
        MySwal.fire({
          title: "Réinitialisation en cours...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => MySwal.showLoading(),
        });
        try {
          //On lance la requête d'envoi de mail
          await recoverAccount(user.email);
          MySwal.fire({
            title: "Lien envoyé avec succès !",
            icon: "success",
            confirmButtonText: "OK",
          });
        } catch (error) {
          //On affiche une alerte en cas d'erreur côté serveur
          MySwal.fire({
            title: "Erreur",
            text: "Échec de l'envoi de l'e-mail. Veuillez réessayer.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  // alert pour supprimer un professeur
  const showdeleteTeacherConfirmationAlert = (teacher: any) => {
    MySwal.fire({
      title: "Supprimer professeur ?",
      text: `Voulez-vous vraiment supprimer ${teacher.firstname} ${teacher.lastname} ?`,
      showCancelButton: true,
      confirmButtonText: "Supprimer",
      cancelButtonText: "Annuler",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // ── Affiche le spinner pendant la requête ──
        MySwal.fire({
          title: "Suppression en cours...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => MySwal.showLoading(),
        });
        try {
          //On lance la requête de suppression
          await deleteTeacher(teacher.id);
          MySwal.fire({
            title: "Professeur supprimé avec succès !",
            icon: "success",
            confirmButtonText: "OK",
          });
          setAllTeachers((prev) =>
            prev.filter((teacherItem) => teacherItem.id !== teacher.id),
          );
        } catch (error) {
          //On affiche une alerte en cas d'erreur côté serveur
          // console.log("Echec de la suppression du professeur: ", error);
          MySwal.fire({
            title: "Erreur",
            text: "Échec de la suppression du professeur. Veuillez réessayer.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  const fetchAllTeachersData = async () => {
    try {
      const response = await getAllTeachers();

      setAllTeachers(response.data);
      setIsLoading(false); //Les données ne sont plus en chargement
      setHasLoaded(true); //Les données ont été chargé avec succès
    } catch (error: any) {
      // console.log("erreur: lors de la récupération des professeurs ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };
  useEffect(() => {
    fetchAllTeachersData();
  }, []);

  // Les colonnes de notre tableau
  const columns = [
    {
      title: "Nom",
      dataIndex: "teacherName",
      render: (text: string, record: any) => (
        <div className="d-flex align-items-center">
          <Link
            to={`/teacher-detail/${record.id}`}
            className="avatar avatar-md"
          >
            <Avvvatars
              value={`${record.firstname?.charAt(0) || ""}${
                record.lastname?.charAt(0) || ""
              }`}
              style="character" // ou "character"
            />
          </Link>
          <div className="ms-2">
            <p className="text-dark mb-0">
              <Link
                to={`/teacher-detail/${record.id}`}
              >{`${record.firstname} ${record.lastname}`}</Link>
            </p>
            {/* <span className="fs-12">{record?.matricule}</span> */}
          </div>
        </div>
      ),
    },
    {
      title: "Sexe",
      dataIndex: "sexe",
      sorter: (a: TeacherDataTable, b: TeacherDataTable) =>
        a?.sexe.length - b?.sexe.length,
    },
    {
      title: "Email",
      dataIndex: "email",
      sorter: (a: TeacherDataTable, b: TeacherDataTable) =>
        a?.email?.length - b?.email?.length,
    },
    {
      title: "Téléphone",
      dataIndex: "number",
      sorter: (a: TeacherDataTable, b: TeacherDataTable) =>
        a?.number?.length - b?.number?.length,
    },
    {
      title: "Spécialité",
      dataIndex: "speciality",
      sorter: (a: TeacherDataTable, b: TeacherDataTable) =>
        a?.speciality.length - b?.speciality.length,
    },
    {
      title: "Statut",
      dataIndex: "statut",
      render: (text: boolean) => (
        <>
          {text == true ? (
            <span className="badge badge-soft-success d-inline-flex align-items-center">
              <i className="ti ti-circle-filled fs-5 me-1"></i>
              Actif
            </span>
          ) : (
            <span className="badge badge-soft-danger d-inline-flex align-items-center">
              <i className="ti ti-circle-filled fs-5 me-1"></i>
              Inactif
            </span>
          )}
        </>
      ),
      sorter: (a: TeacherDataTable, b: TeacherDataTable) =>
        a?.statut === b?.statut ? 0 : a?.statut ? -1 : 1,
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_: any, record: any) => {
        return (
          <>
            <div className="d-flex align-items-center">
              <div className="dropdown">
                <Link
                  to="#"
                  className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="ti ti-dots-vertical fs-14" />
                </Link>
                <ul className="dropdown-menu dropdown-menu-right p-3">
                  <li>
                    <Link
                      className="dropdown-item rounded-1"
                      to={`/teacher-detail/${record.id}`}
                    >
                      <i className="ti ti-menu me-2" />
                      Détails Professeur
                    </Link>
                  </li>
                  {/* reinitaliser mot de passe */}
                  <ProtectedBtnResetPasword
                    record={record}
                    showConfirmationAlert={showConfirmationAlert}
                  />

                  {/* supprimer un professeur */}
                  <ProtectedBtnDeleteTeacher
                    showdeleteTeacherConfirmationAlert={
                      showdeleteTeacherConfirmationAlert
                    }
                    record={record}
                  />
                </ul>
              </div>
            </div>
          </>
        );
      },
    },
  ];

  return (
    <>
      {/* Page wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <DashboardMenu />
            <div className="d-flex ">
              {/* Boutton en entête de la page */}
              <ProtectedAddTeacher
                routes={routes}
                updateData={fetchAllTeachersData}
              />
            </div>
          </div>
          {/* /Page Header */}
          {!selectedYear?.statut && <InfosAlertYearDisabled />}
          {/* Tableau liste des parents */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Liste des professeurs</h4>
              <div className="d-flex align-items-center flex-wrap">
                <div className="input-icon-start me-2 position-relative">
                  <Link
                    to={routes.hourlyRateTeacher}
                    className="btn btn-light d-flex align-items-center me-3 mb-2"
                  >
                    <i className="ti ti-wallet me-2" />
                    Taux horaire
                  </Link>
                </div>
              </div>
            </div>
            <div className="card-body p-0 py-3">
              {/* Students List (On affiche le tableau qui si les données son chargées même vide) */}
              {isLoading && !hasLoaded ? (
                <div className="text-center">
                  <div className="spinner-border" role="status"></div>
                  <span className="visually">Chargement des Données...</span>
                </div>
              ) : (
                <Table
                  columns={columns}
                  dataSource={allTeachers}
                  Selection={true}
                />
              )}
              {/* /Staffs List */}
            </div>
          </div>
        </div>
      </div>

      {/* / Page wrapper */}
    </>
  );
};

export default AllTeacher;
